import { useEffect, useRef } from 'react';
import { useReorderSteps } from './useReorderSteps';

import { useSweepCanvasPropsCtx } from '../internal-context/SweepCanvasPropsCtx';
import { useFeatureToggle } from '../../common/useFeatureToggle';
import isEqual from 'lodash/isEqual';
import { ReorderSteps } from './ReorderStepsCtx';

export const useReorderStepsEffect = () => {
  const { activateReorderStepsMode, deactivateReorderStepsMode } = useReorderSteps();
  const { reorderStepsMode } = useSweepCanvasPropsCtx();
  const previousReorderSteps = useRef<ReorderSteps | undefined>(undefined);
  const { canvasReorderSteps } = useFeatureToggle();

  useEffect(() => {
    if (!canvasReorderSteps) {
      return;
    }
    if (reorderStepsMode) {
      if (!previousReorderSteps.current) {
        previousReorderSteps.current = reorderStepsMode;
        activateReorderStepsMode(reorderStepsMode);
      } else {
        if (!isEqual(previousReorderSteps.current, reorderStepsMode)) {
          previousReorderSteps.current = reorderStepsMode;
          deactivateReorderStepsMode();

          setTimeout(() => {
            activateReorderStepsMode(reorderStepsMode);
          }, 100);
        }
      }
    } else {
      if (previousReorderSteps.current) {
        deactivateReorderStepsMode();
        previousReorderSteps.current = undefined;
      }
    }
  }, [activateReorderStepsMode, canvasReorderSteps, deactivateReorderStepsMode, reorderStepsMode]);
};
